import { Component, ViewChild, ElementRef, HostListener, OnInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { ActionSheetController, LoadingController, AlertController, IonSelect,Platform,IonInfiniteScroll } from '@ionic/angular';
import { NativeService } from '../../../../service/native.service';
import { WebParameterContext } from '../../../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { MapclientServiceService } from '../../../../service/mapclient.service.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { DomSanitizer } from '@angular/platform-browser';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { Device } from '@ionic-native/device/ngx';
import { EmitserviceService } from 'src/service/emitservice.service';
declare var app;
@Component({
  selector: 'app-a2-activity-center-detail2',
  templateUrl: './a2-activity-center-detail2.component.html',
  styleUrls: ['./a2-activity-center-detail2.component.scss']
})
export class A2ActivityCenterDetail2Component extends GridBaseCase implements OnInit {

  @ViewChild('map') map_container: ElementRef;
  @ViewChild('selectDom') ionSelect: IonSelect;
  imgUrlArr = [];//门头照
  imgUrlSignInArr = [];//签到照片
  imgUrlSceneArr = [];//现场照片
  imgUrlActivityArr = [];//活动机制照片
  imgUrlOtherArr = [];//其他照片
  systemUserList: Array<any> = new Array<any>();
  object: any = {};

  tabsIndex = 0;//选中tabs
  activityArr = [];//关联妈妈班活动列表
  selectActivityId = "000000";//妈妈班活动id
  selectActivityVal = "无";//妈妈班活动名称
  receiveTypeArr = [];//活动赠送类别
  selectReceiveId = null;//赠送类别Id
  selectReceiveCode = null;//赠送类别code
  selectReceiveVal = null;//赠送类别名称
  milkNumOld = "";//奶卡卡号
  otherNumOld = "";//其他卡号
  isValidMilk = false;//奶卡卡号是否有效
  isValidOther = false;//其他编号是否有效
  isClickSelect = false;
  isLeading = false;//是否是省区负责人、区域负责人

  isBeginSevenDay: Boolean = false;//活动是否开始7天以前
  isendSevenDay: Boolean = false;//活动是否结束7天以内
  isFuzeren: Boolean = false;//是否是负责人
  isEnd: Boolean = false;//活动是否已结束
  flag: any = null;//活动状态 1进行中 2未开始 0已结束
  locationerror: boolean = false;//定位失败备注，默认定位成功不显示
  locationIsLoading: boolean = false;//定位是否完成
  activityId: string = null;//奶卡活动id
  isShowSelect: boolean = true;
  isSubmitData: boolean = true;//是否可以提交数据
  Activity2CacheFormId: any = "";//缓存formid
  NewFormId: string = "";//每次刷新后的formid
  orderListArr: any = [];//妈妈班关联鲜入为主订单列表
  Activity2CacheData: any = {
    formId: "",//表单id
    selectReceiveId: "",//赠送类别id
    selectReceiveCode: "",//赠送类别code
    selectReceiveVal: "",//赠送类别名称
    Remarks: "",//定位备注
    milkNum: "",//奶卡卡号
    otherNum: "",//其他编号
    orderId: null,//扫码销量订单号
    orderQrCodeUrl: "",//订单二维码
    actQrCodeIsUsed: false,//活动码已使用
    isRelationActivity: false,//是否关联妈妈班
    freshIntakeCode: ""//表示扫活动码生成的活动码数据
  };//活动缓存数据
  orderInfo: any = {};//订单信息
  isfreshIntake: boolean = false;//先入为主扫活动时如果扫码按钮触发就设置为true,当前扫活动码不可用
  allReceiveType:any = [];//赠送类型全局变量
  actOrderInfoId:any = "";//妈妈班关联奶卡活动的订单号
  actOrderInfoVal:any = "";//妈妈班关联奶卡活动的选中项
  vipId:any = "";//妈妈班关联会员id
  writeOff:any=60;//会员在60个自然日内产生购买才能核销
  constructor(
    private map: MapclientServiceService,
    private nativeService: NativeService,
    private actionSheet: ActionSheetController,
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public keyboard: Keyboard,
    public base: BaseModal,
    public sanitizer: DomSanitizer,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public barcode: BarcodeScanner,
    private device: Device,
    private emitservice: EmitserviceService

  ) {
    super();
    let that = this;
    that.writeOff = app.writeOff;
    this.activityId = this.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    this.flag = parseInt(this.activaRouter.snapshot.paramMap.get('id').split("&")[1]);
    if (this.flag == 2) {
      this.baseService.isbuttonvisble = false;
    }

    this.hideKeyboard();//键盘隐藏触发事件

    if (that.com.GetAccount.Roles) {
      that.com.GetAccount.Roles.forEach(item => {
        if (item.Code == "1007" || item.Code == "1008" || item.Code == "1009") {
          that.isLeading = true;
        }
      })
    }
  }

  ngOnInit() {
    let that = this;
    that.emitservice.eventEmit.subscribe((value) => {
      console.log(value, "接受值");
      if(value){
        if(value["orderQRCode"]){//扫活动码
          if(that.com.GetStorageKey("orderQRCode")){
            console.log(value,"返回值");
            let _tempID=that.com.GetStorageKey("orderQRCode");
            that.getMemberInfo(_tempID.a_FormID);
            localStorage.removeItem("orderQRCode");
          }
        }else if (value["orderId"]) {
          that.Activity2CacheData.orderId = value["orderId"];
          if (value["orderQrCodeUrl"]) {
            that.Activity2CacheData.orderQrCodeUrl = value["orderQrCodeUrl"];
          }
          localStorage.removeItem("orderQRID");
          that.saveLocation();;
          that.getOrderInfo(3);//获取订单信息
        }
      }
   
      // that.objvalue=JSON.stringify(value);
    });
    /**
     * 获取缓存数据
     */

    const _param = this.activaRouter.snapshot.paramMap.get('id').split("&");
    const _scenePicture = that.com.GetStorageKey("activity_a_ScenePicture");

    if (_param.length > 3 && _param[2] == "mamaban") {
      const _Activity2CacheData = that.com.GetStorageKey("Activity2CacheData_MMB_" + that.com.GetAccount.Id+ "_" + that.activityId);
      if (_Activity2CacheData && _Activity2CacheData["isRelationActivity"] == true) {
        that.Activity2CacheData = _Activity2CacheData;
      }
      that.Activity2CacheData.isRelationActivity = true;
      // that.getActivityList();//妈妈班活动列表
      const actNameAndId = that.com.GetStorageKey("actNameAndId");
      if (actNameAndId) {
        that.selectActivityVal = actNameAndId["Name"];
        that.selectActivityId = actNameAndId["Id"];
      }
      if(_param[4]){
        that.vipId = _param[4];//会员id
      }
      // that.getReceiveList();//赠送类别 
      that.LoadData();
    } else {
      const _Activity2CacheData = that.com.GetStorageKey("Activity2CacheData_" + that.com.GetAccount.Id+ "_" + that.activityId);
      if (_Activity2CacheData && _Activity2CacheData["isRelationActivity"] == false) {
        that.Activity2CacheData = _Activity2CacheData;
      }
      if (that.Activity2CacheData.freshIntakeCode) {//如果扫活动码的Code存在
        that.isfreshIntake = true;
        //#region 保存扫活动码时的会员信息
        const orderinfo = that.com.GetStorageKey("orderInfo_" + that.com.GetAccount.Id + "_" + that.activityId);
        if (orderinfo) {
          that.orderInfo = orderinfo;
        }
        //#endregion
      }
      if (that.Activity2CacheData.orderId) {
        that.getOrderInfo();
      }
      that.Activity2CacheData.isRelationActivity = false;
      that.getReceiveList();//赠送类别
      that.LoadData();
    }
    

    if (that.Activity2CacheData.selectReceiveCode == "GC001" || that.Activity2CacheData.selectReceiveCode == "GC005") {
      that.imgUrlSceneArr = that.getCameraList("a_ScenePicture", that.object["a_ScenePicture"]);
    }

  }

  /**
   * 缓存数据
   */
  saveLocation() {
    const that = this;
    if (that.Activity2CacheData.isRelationActivity) {
      localStorage.setItem("Activity2CacheData_MMB_" + that.com.GetAccount.Id + "_" + that.activityId, JSON.stringify(that.Activity2CacheData));
    } else {
      localStorage.setItem("Activity2CacheData_" + that.com.GetAccount.Id + "_" + that.activityId, JSON.stringify(that.Activity2CacheData));
    }
  }


  /**
   * 订单二维码
   */
  bindOrder() {
    const that = this;
    if(that.orderInfo.FK_MembersInfoManagement_ID){
      that.msg.Alert("此二维码已绑定过会员，该二维码已失效");
    }else{
      let emitJson:any = {
        "orderId":that.Activity2CacheData.orderId,
        "orderQrCodeUrl":that.Activity2CacheData.orderQrCodeUrl,
        "orderProductsList":[]
      }
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "GetOrderInfo";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = 15;
      body.PageNumber = 1;
      body.RequestBody = JSON.stringify({ "Order_ID": that.Activity2CacheData.orderId })
      that.msg.Loading("请稍后...").then(loads => {
        that.http.post(app.DEFAULTURL, body).then(data => {
        
          // that.emitService.eventEmit.emit(emitJson);
         
          if (data.ResponseMessage.Success) {
            if (data.Status.Datas.length > 0) {
              that.orderInfo = data.Status.Datas[0];
              if (that.orderInfo["TankBarcodes"]) {
                that.orderInfo["TankBarcodes"] = that.orderInfo["TankBarcodes"].split(",");
              }
              if(that.orderInfo.FK_MembersInfoManagement_ID){
                that.msg.Alert("此二维码已绑定过会员，该二维码已失效");
              }else{
                if (that.Activity2CacheData.orderQrCodeUrl) {
                  console.log("二维码");
                  that.com.setHistoryUrl();
                  localStorage.setItem("orderQRID",JSON.stringify(emitJson));
                  that.com.goQrCode(that.Activity2CacheData.orderQrCodeUrl, "activityOrder", "订单二维码");
                }
              }
            }
          }else{
            if (that.Activity2CacheData.orderQrCodeUrl) {
              console.log("二维码");
              that.com.setHistoryUrl();
              localStorage.setItem("orderQRID",JSON.stringify(emitJson));
              that.com.goQrCode(that.Activity2CacheData.orderQrCodeUrl, "activityOrder", "订单二维码");
            }
          }
        }).catch(err => {
          if (that.Activity2CacheData.orderQrCodeUrl) {
            console.log("二维码");
            that.com.setHistoryUrl();
            localStorage.setItem("orderQRID",JSON.stringify(emitJson));
             
            that.com.goQrCode(that.Activity2CacheData.orderQrCodeUrl, "activityOrder", "订单二维码");
          }
        });
      })
    }
    // if (this.Activity2CacheData.orderQrCodeUrl) {
    //   console.log("二维码");
    //   this.com.setHistoryUrl(false);
    //   this.com.goQrCode(this.Activity2CacheData.orderQrCodeUrl, "activityOrder", "订单二维码");
    // }

  }
  /**
   * 获取订单信息
   */
  getOrderInfo(n:any = 0) {
    const that = this;
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "GetOrderInfo";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 15;
    body.PageNumber = 1;
    body.RequestBody = JSON.stringify({ "Order_ID": that.Activity2CacheData.orderId })
    that.msg.Loading("请稍后...").then(loads => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        setTimeout(function(){
          loads.dismiss();
        },100);
        if (data.ResponseMessage.Success) {
          if (data.Status.Datas.length > 0) {
            that.orderInfo = data.Status.Datas[0];
            if (that.orderInfo["TankBarcodes"]) {
              that.orderInfo["TankBarcodes"] = that.orderInfo["TankBarcodes"].split(",");
            }
          }
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        loads.dismiss();
        that.msg.Alert("网络异常，请稍后再试！");
      });
      if(n == 0){//手动刷新时添加加载效果
        loads.present();
      }
    })
  }
  /**
   * 删除活动会员
   */
  deleteMember(n:any = 1) {
    const that = this;
    if(n == 1){
      that.msg.Confirm("确定删除吗？", "取消", "确定", "", false).then(fail => {
        if (fail) {
          const that = this;
          // if(!that.Activity2CacheData.freshIntakeCode || !that.activityId){
          //   delete that.orderInfo["Name"];
          //   delete that.orderInfo["TelPhone"];
          //   delete that.orderInfo["Register_time"];
          //   delete that.orderInfo["FirstOrderTime"];
          //   that.Activity2CacheData.freshIntakeCode = "";
          //   that.isfreshIntake = false;
          //   that.saveLocation();
          //   localStorage.removeItem("orderInfo_"+that.com.GetAccount.Id+"_"+that.activityId);//删除扫活动码会员信息
          //   return;
          // }
          let body = new WebParameterContext();
          body.Account = that.com.GetAccount;
          body.ConfigName = "TBMemberSign";
          body.OpType = "delete";
          body.ConfigType = "form";
          body.RowsPerPage = 15;
          body.PageNumber = 1;
          let signInfo = {};
              signInfo["a_FormID"] = that.Activity2CacheData.freshIntakeCode;
              signInfo["a_FK_TBActivity_ID"] = that.activityId;
          body.RequestBody = JSON.stringify(signInfo);
          that.msg.Loading("请稍后...").then(loads => {
            that.http.post(app.DEFAULTURL, body).then(data => {
              loads.dismiss();
              if (data.ResponseMessage.Success) {
                  that.orderInfo = {};
                  that.Activity2CacheData.freshIntakeCode = "";
                  that.isfreshIntake = false;
                  that.saveLocation();
                  localStorage.removeItem("orderInfo_"+that.com.GetAccount.Id+"_"+that.activityId);//删除扫活动码会员信息
              } else {
                that.msg.Alert(data.ResponseMessage.ErrorMessage);
              }
            }).catch(err => {
              loads.dismiss();
              that.msg.Alert("网络异常，请稍后再试！");
            });
            loads.present();
          });
          
        }
      });
    }else{
      const that = this;
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      body.ConfigName = "TBMemberSign";
      body.OpType = "delete";
      body.ConfigType = "form";
      body.RowsPerPage = 15;
      body.PageNumber = 1;
      let signInfo = {};
          signInfo["a_FormID"] = that.Activity2CacheData.freshIntakeCode;
          signInfo["a_FK_TBActivity_ID"] = that.activityId;
      body.RequestBody = JSON.stringify(signInfo);
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
            // delete that.orderInfo["Name"];
            // delete that.orderInfo["TelPhone"];
            // delete that.orderInfo["Register_time"];
            // delete that.orderInfo["FirstOrderTime"];
            // delete that.orderInfo['FK_MembersInfoManagement_ID'];
            that.orderInfo = {};
            that.Activity2CacheData.freshIntakeCode = "";
            that.isfreshIntake = false;
            that.saveLocation();
            localStorage.removeItem("orderInfo_"+that.com.GetAccount.Id+"_"+that.activityId);//删除扫活动码会员信息
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        that.msg.Alert("网络异常，请稍后再试！");
      });
    }
  }
  /**
   * 获取扫活动码返回的会员信息
   */
  getMemberInfo(data:any="") 
  {
    const that = this;
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "TBMemberSignInfo";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 15;
    body.PageNumber = 1;
    let parms = { "a_FK_SystemUser_Create_ID": that.com.GetAccount.Id };
         parms["a_FormID"] = that.Activity2CacheData.freshIntakeCode;
    if(data){
      parms["a_FormID"] = data;
    }
    parms["a_FK_TBActivity_ID"] = that.activityId;
    body.RequestBody = JSON.stringify(parms);
    that.msg.Loading("请稍后...").then(loads => {
      that.http.post(app.DEFAULTURL, body).then(data => {
        setTimeout(function(){
          loads.dismiss();
        },100);
        if (data.ResponseMessage.Success) {
          if (data.Status) {
            let ob: any = data.Status;
            that.orderInfo["Name"] = ob.b_Name;
            that.orderInfo["IsOrder"] = ob.IsOrder;
            that.orderInfo["TelPhone"] = ob.b_TelPhone;
            that.orderInfo["Register_time"] = ob.b_Register_time;
            that.orderInfo["FirstOrderTime"] = ob.c_FirstOrderTime;
            that.orderInfo["FK_MembersInfoManagement_ID"] = ob.a_FK_MembersInfoManagement_ID;
            localStorage.setItem("orderInfo_" + that.com.GetAccount.Id + "_" + that.activityId, JSON.stringify(that.orderInfo));//保存活动ID
          }
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        loads.dismiss();
        that.msg.Alert("网络异常，请稍后再试！");
      });
      loads.present();
    })
  }

  /**
   * 删除订单信息
   */
  deleteOrderInfo(n: any = 1) {
    const that = this;
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "ProductPurchaseRecordAppXML";
    body.OpType = "REALDELETE";
    body.ConfigType = "view";
    body.RequestBody = JSON.stringify({ "a_Order_ID": that.Activity2CacheData.orderId });
    if (n == 1) {
      that.msg.Confirm("确认删除？").then(data => {
        if (data) {
          that.msg.Loading("请稍后...").then(loads => {
            that.http.post(app.DEFAULTURL, body).then(data => {
              loads.dismiss();
              if (data.ResponseMessage.Success) {
                that.Activity2CacheData.orderId = null;
                that.Activity2CacheData.orderQrCodeUrl = "";
                that.orderInfo = {};
                that.saveLocation();
                that.msg.Alert("删除成功！");
              } else {
                that.Activity2CacheData.orderId = null;
                that.Activity2CacheData.orderQrCodeUrl = "";
                that.orderInfo = {};
                that.saveLocation();
                that.msg.Alert(data.ResponseMessage.ErrorMessage);
              }
            }).catch(err => {
              loads.dismiss();
              that.msg.Alert("网络异常，请稍后再试！");
            });
            loads.present();
          })
        }
      })
    } else {
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          that.Activity2CacheData.orderId = null;
          that.Activity2CacheData.orderQrCodeUrl = "";
          that.orderInfo = {};
          that.saveLocation();;
        } else {
          that.Activity2CacheData.orderId = null;
          that.Activity2CacheData.orderQrCodeUrl = "";
          that.orderInfo = {};
          that.saveLocation();
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        that.msg.Alert("网络异常，请稍后再试！");
      });
    }

  }


  /**
   * 手动输入
   */
  async presentAlertInput() {
    const that = this;
    const alert = await this.alertCtrl.create({
      header: '请输入其他编号',
      mode: "ios",
      inputs: [
        {
          name: 'a_Code',
          type: 'text',
          label: '请输入其他编号',
          value: '',
          min: 6
        }
      ],
      buttons: [
        {
          text: "确认",
          cssClass: 'btn-okay',
          handler: (Okay) => {
            //console.log(Okay,"ok");
            if (Okay && Okay["a_Code"] && that.vlidateOtherNumber(Okay["a_Code"])) {
              that.vlidateOtherNumberByApi(Okay["a_Code"]);
            } else {
              that.msg.Alert("请输入正确的编号！").then(data => {
                that.presentAlertInput();
              });
            }

          }
        },
        {
          text: "取消",
          role: 'cancel',
          cssClass: 'secondary btn-cancel',
          handler: (cancel) => {
            //console.log(cancel,"cancel");
          }
        }
      ]
    });

    await alert.present();
  }

  /**
* 扫码
*  
*/
  scanQrcode() {
    const that = this;

    if (that.platform.is('cordova')) {
      // that.com.setHistoryUrl();
      that.barcode.scan().then((scan) => {
        // let sancanArray: Array<any> = new Array<any>();
        // sancanArray = that.com.GetStorageKey("backurl") || [];
        // sancanArray.splice(sancanArray.length - 1, 1);
        // localStorage.setItem("backurl", JSON.stringify(sancanArray));
        const _code = scan.text;
        if (_code && _code.indexOf("http") == -1) {
          that.vlidateOtherNumberByApi(_code);
        }else if(_code && _code.indexOf("http") > -1){
          let _param = _code.split("?");
          if(_param.length >= 2){
            let _qrCode = _param[1].split("=");
            if(_qrCode.length == 2 && _qrCode[1]){
              that.vlidateOtherNumberByApi(_qrCode[1]);
            } else {
              that.msg.Alert("请扫描正确的编号！");
            }
          } else {
            that.msg.Alert("请扫描正确的编号！");
          }
        } else {
          that.msg.Alert("请扫描正确的编号！");
        }
        // if (PageName) {
        //   if (PageName == "ScanCodeSales") {
        //     let _obj = {};
        //     if(scan.text){
        //       _obj["Code"] = scan.text;
        //       // that.LoadDataBind(_obj);
        //     }
        //   }
        // }
      }).catch(error => {
        that.msg.Show(error);
      });
    } else {
      that.msg.Show("暂不支持", "middle");
    }
  }


  /**
   * 
   * 选择扫码或手工输入
   */
  async presentAlertCheck() {
    const that = this;
    let isplatform: boolean = false;
    if (that.platform.is("cordova")) {
      if (that.platform.is("android")) {
        if (that.device.version) {
          if (that.device.version.toString().startsWith("4")) {
            isplatform = true;
          } else if (that.device.version.toString().startsWith("3")) {
            isplatform = true;
          } else if (that.device.version.toString().startsWith("2")) {
            isplatform = true;
          }
        }
      }
    };
    if (isplatform) {
      if (window.confirm("请选择扫码方式,【确定】表示扫码,【取消】表示手动输入")) {
        that.com.setHistoryUrl();
        that.scanQrcode();
      } else {
        var code = window.prompt("请输入其他编号", "");
        if (code && that.vlidateOtherNumber(code)) {
          that.vlidateOtherNumberByApi(code);
          // that.LoadDataBind(_obj);
        } else {
          that.msg.Alert("请输入正确的编号！");
        }
      }
    } else {
      const alert = await this.alertCtrl.create({
        header: '系统提示',
        message: "请选择方式",
        mode: "ios",
        cssClass: "more-btn",
        buttons: [
          {
            text: "扫码识别",
            cssClass: 'btn-okay btn-width',
            handler: (Okay = "1") => {
              // console.log(Okay,"ok");
              that.scanQrcode();
            }
          },
          {
            text: "手动输入",
            cssClass: 'btn-okay btn-width',
            handler: (Okay1 = "2") => {
              // console.log(Okay1,"ok1");
              that.presentAlertInput();
            }
          },
          {
            text: "取消",
            role: 'cancel',
            cssClass: 'secondary btn-cancel btn-width',
            handler: (cancel) => {
              console.log(cancel, "cancel");
            }
          }
        ]
      });
      await alert.present();
    }
  }

  /**
   * 验证其他编号正确性。
   * @param num 
   */
  vlidateOtherNumber(num) {
    const code = new RegExp("^[0-9]*$");
    if (num != null && num != undefined && code.test(num) && num.toString().trim().length == 16) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 调接口验证其他编号（先验证是否与扫码销量罐码重复）
   */
  vlidateOtherNumberByApi(num) {
    const that = this;
    if (that.orderInfo["TankBarcodes"] && that.orderInfo["TankBarcodes"].toString().indexOf(num) > -1) {
      that.msg.Alert("其他编码不能与销售罐码重复");
      return;
    }
    //
    let _obj = {
      "ConfigName": "ActivityNumcar",
      "OpType": "query",
      "ConfigType": "view",
      "RequestBody": JSON.stringify({ "AotherNum": num })
    };
    that.msg.Loading("请稍后...").then(loads => {
      that.http.post(app.DEFAULTURL, _obj).then(data => {
        loads.dismiss();
        if (data.ResponseMessage.Success) {
            that.object.otherNum = num;
            that.Activity2CacheData.otherNum = num;
            that.saveLocation();
        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(err => {
        loads.dismiss();
        that.msg.Alert("网络异常，请稍后再试！");
      });
      loads.present();
    })
  }

  /**
 * 获取定位
 */
  getLocation(isReGetLocation: boolean = false) {
    const that = this;
    that.locationIsLoading = false;

    if (isReGetLocation) {
      that.object.Address = "";
      that.object.a_Latitude = "";
      that.object.a_Longitude = "";
    }

    // if (that.platform.is("android") && that.platform.is("cordova")) {
      if (that.platform.is("cordova")) {
      that.map.getGDCurrentPosition().then(data=>{
        that.locationIsLoading = true;
        that.locationerror = false;
        that.object.Address = that.com.GetChineselanage(data.address);
        that.object.a_Latitude = data.latitude;
        that.object.a_Longitude = data.longitude;
      }).catch(err=>{
        that.locationerror = true;
        that.locationIsLoading = true;
        console.log("定位失败,请联系管理员");
      });
      // that.map.getCurrentPosition().then(data => {
      //   that.locationIsLoading = true;
      //   that.locationerror = false;
      //   that.object.Address = that.com.GetChineselanage(data.address);
      //   that.object.a_Latitude = data.latitude;
      //   that.object.a_Longitude = data.longitude;
      // }).catch(error => {
      //   that.locationerror = true;
      //   that.locationIsLoading = true;
      //   console.log("定位失败,请联系管理员");
      // });
    } else {
      that.map.Geolocation(that.map_container.nativeElement).then(data => {
        // loads.dismiss();
        that.locationIsLoading = true;
        that.locationerror = false;
        that.object.Address = that.com.GetChineselanage(data.formattedAddress);
        that.object.a_Latitude = data.position.lat;
        that.object.a_Longitude = data.position.lng;
      }).catch(error => {
        that.locationerror = true;
        that.locationIsLoading = true;
        // loads.dismiss();
      });
    }
  }

  /**
   * 赠品类型
   * @param $event 
   * GC001 奶卡-非消费送
   * GC005 奶卡-消费送
   * GC002 其他-买赠
   * GC003 其他-优惠/礼包
   * GC004 其他-完全赠送
   */
  changeReceiveSelect($event) {
    let val = $event.detail.value;
    console.log(val);
    let that = this;
    let tip = "是否确认变更赠送类别？确定将清空关联、及填写的信息！";
    if (that.Activity2CacheData.isRelationActivity) {
      tip = "是否确认变更赠送类别？确定将清空填写的信息！";
    }
    if (val != that.selectReceiveCode && (that.Activity2CacheData.orderId || that.Activity2CacheData.otherNum || that.Activity2CacheData.milkNum || that.Activity2CacheData.freshIntakeCode)) {
      that.msg.Confirm(tip).then(data => {
        if (data) {
          that.selectReceiveCode = val;
          that.isShowSelect = false;
          that.receiveTypeArr.forEach((item, index) => {
            item["isCheck"] = false;
            if (item['a_Code'] == val) {
              item["isCheck"] = true;
              that.selectReceiveVal = item["a_Name"];
              that.selectReceiveId = item["a_ID"];
            }
          });
          setTimeout(() => {
            that.isShowSelect = true;
          }, 500);//重新渲染select组件
          that.Activity2CacheData.selectReceiveId = that.selectReceiveId;
          that.Activity2CacheData.selectReceiveVal = that.selectReceiveVal;
          that.Activity2CacheData.selectReceiveCode = that.selectReceiveCode;
          that.saveLocation();;//缓存填写数据

          that.clearOtherTypeData();//清除数据
        } else {
          console.log("取消");
          that.isShowSelect = false;
          setTimeout(() => {
            that.isShowSelect = true;
          }, 500);//重新渲染select组件
        }
      })
    } else {

      that.selectReceiveCode = val;
      that.isShowSelect = false;
      that.receiveTypeArr.forEach((item, index) => {
        item["isCheck"] = false;
        if (item['a_Code'] == val) {
          item["isCheck"] = true;
          that.selectReceiveVal = item["a_Name"];
          that.selectReceiveId = item["a_ID"];
        }
      });
      setTimeout(() => {
        that.isShowSelect = true;
      }, 500);//重新渲染select组件
      that.Activity2CacheData.selectReceiveId = that.selectReceiveId;
      that.Activity2CacheData.selectReceiveVal = that.selectReceiveVal;
      that.Activity2CacheData.selectReceiveCode = that.selectReceiveCode;
      that.saveLocation();;//缓存填写数据
    }

  }

  /**
   * 清除其他类型数据
   */
  clearOtherTypeData() {
    const that = this;
    if (!that.Activity2CacheData.isRelationActivity) {
      if (that.Activity2CacheData.orderId) {
        that.deleteOrderInfo(2);//清除订单数据
      }
      if(that.Activity2CacheData.freshIntakeCode){
        that.deleteMember(2);//删除会员
      }
    }

    that.imgUrlSceneArr = [];
    localStorage.removeItem("activity_a_ScenePicture");

    if (that.Activity2CacheData.otherNum) {
      that.Activity2CacheData.otherNum = "";
      that.object.otherNum = "";
    }
    if (that.Activity2CacheData.milkNum) {
      that.Activity2CacheData.milkNum = "";
      that.object.milkNum = "";
    }
    that.saveLocation();;
  }

  /**
   * 妈妈班关联鲜入为主时，多个订单筛选
   */
  changeOrderSelect(event) {
    const that = this;
    let val = event.detail.value;
    if(that.actOrderInfoId != val ){
      that.msg.Confirm("是否确认切换订单？切换订单后赠送类别可能会发生变化！").then(data=>{
        if(data){
          that.orderListArr.forEach((item,index) => {
            item["isCheck"] = false;
            if (val == item["Order_ID"]) {
              item["isCheck"] = true;
              that.orderInfo = item;
              that.actOrderInfoId = val;
              that.actOrderInfoVal = (item["Name"] || "")+"-"+item["Order_ID"];
              that.checkReceiveTypeByActStatus(index);
            }
          })
        }
      })
    }
    
  }

  /**
   * 根据会员订单状态显示赠送类别
   */
  checkReceiveTypeByActStatus(n:any = 0){
    const that = this;
    that.receiveTypeArr = [];
    if (that.object["OrderList"] && that.object["OrderList"].length > 0 && that.object["OrderList"][n]["IsFirstOrder"]) {
      //有订单-有销量-首次购买
      that.receiveTypeArr = that.allReceiveType;
      if(n == 0){
        that.object["OrderList"][0]["isCheck"] = true;
        that.actOrderInfoId = that.object["OrderList"][0]["Order_ID"];
        that.actOrderInfoVal = (that.object["OrderList"][0]["Name"] || "")+"-"+that.object["OrderList"][0]["Order_ID"];
      }
    } else if (that.object["OrderList"] && that.object["OrderList"].length > 0 && !that.object["OrderList"][n]["IsFirstOrder"]) {
      //有订单-有销量-非首次购买
      that.allReceiveType.forEach(item => {
        if (item["a_Code"] == "GC001" || item["a_Code"] == "GC005") {
          that.receiveTypeArr.push(item);
        }
      })
      if(n == 0){
        that.object["OrderList"][0]["isCheck"] = true;
        that.actOrderInfoId = that.object["OrderList"][0]["Order_ID"];
        that.actOrderInfoVal = (that.object["OrderList"][0]["Name"] || "")+"-"+that.object["OrderList"][0]["Order_ID"];
      }
    }else if (that.object["SignInfo"] && JSON.stringify(that.object["SignInfo"]) != "{}" && that.object["SignInfo"]["IsOrder"]) {
      //有签到信息，有历史订单信息
      that.allReceiveType.forEach(item => {
        if (item["a_Code"] == "GC001") {
          that.receiveTypeArr.push(item);
        }
      })
    }else if (that.object["SignInfo"] && JSON.stringify(that.object["SignInfo"]) != "{}" && !that.object["SignInfo"]["IsOrder"]) {
      //只有签到信息，无历史订单信息
      that.allReceiveType.forEach(item => {
        if (item["a_Code"] == "GC001" || item["a_Code"] == "GC004") {
          that.receiveTypeArr.push(item);
        }
      })
    } else{
      that.allReceiveType.forEach(item => {
        if (item["a_Code"] == "GC001") {
          that.receiveTypeArr.push(item);
        }
      })
    }
    that.isShowSelect = false;
    // if(that.receiveTypeArr.length>0){
    //     that.receiveTypeArr[0]["isCheck"] = true;
    //     that.selectReceiveCode = that.receiveTypeArr[0].a_Code;
    //     that.selectReceiveVal = that.receiveTypeArr[0].a_Name;
    //     that.selectReceiveId = that.receiveTypeArr[0].a_ID;
    //     that.saveLocation();
    // }

    if (that.receiveTypeArr.length > 0) {
      /**
       * 如果缓存中有当前选择的类型，选中缓存项
       * 如果缓存中没有，将第一个赠送类型缓存,默认选中第一个
       */
      
      that.selectReceiveCode = that.receiveTypeArr[0].a_Code;
      that.selectReceiveVal = that.receiveTypeArr[0].a_Name;
      that.selectReceiveId = that.receiveTypeArr[0].a_ID;
      let isHasCheck = false;
      that.receiveTypeArr.forEach(item => {
        item["isCheck"] = false;
        if (item["a_ID"] == that.Activity2CacheData["selectReceiveId"]) {
          item["isCheck"] = true;
          isHasCheck = true;
          that.selectReceiveCode = item.a_Code;
          that.selectReceiveVal = item.a_Name;
          that.selectReceiveId = item.a_ID;
        }
      })
      if(!isHasCheck){
        that.receiveTypeArr[0]["isCheck"] = true;
        that.Activity2CacheData.selectReceiveId = that.selectReceiveId;
        that.Activity2CacheData.selectReceiveVal = that.selectReceiveVal;
        that.Activity2CacheData.selectReceiveCode = that.selectReceiveCode;
        that.saveLocation();;//缓存填写数据
      }
    }

    setTimeout(()=>{
      that.isShowSelect = true;
    },500);
  }

  /**
   * 获取赠送类别数据
   */
  getReceiveList() {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "GiftsCategory";
    body.OpType = "query";
    body.ConfigType = "view";
    // body["QueryOrderBy"] = [
    //   {
    //     "OrderByColumnName": "a_Code",
    //     "OrderByType": "asc"
    //   }
    // ];
    // body.RowsPerPage = 100;
    // body.RowsPerPage = app.RowsPerPage;
    // body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.isShowSelect = false;
        if (that.Activity2CacheData.isRelationActivity) {
          that.receiveTypeArr = [];
          that.allReceiveType = data.Status.Datas;
          that.checkReceiveTypeByActStatus();//筛选赠送类别
        } else {
          that.receiveTypeArr = data.Status.Datas;
        }
        if (that.receiveTypeArr.length > 0) {
          that.receiveTypeArr[0]["isCheck"] = true;
          that.selectReceiveCode = that.receiveTypeArr[0].a_Code;
          that.selectReceiveVal = that.receiveTypeArr[0].a_Name;
          that.selectReceiveId = that.receiveTypeArr[0].a_ID;
          /**
           * 刷新页面后选择
           */
          if (that.Activity2CacheData && that.Activity2CacheData["selectReceiveId"]) {
            let isHasCheck = false;
            that.receiveTypeArr.forEach(item => {
              item["isCheck"] = false;
              if (item["a_ID"] == that.Activity2CacheData["selectReceiveId"]) {
                item["isCheck"] = true;
                isHasCheck = true;
                that.selectReceiveCode = item.a_Code;
                that.selectReceiveVal = item.a_Name;
                that.selectReceiveId = item.a_ID;
              }
            })
            if(!isHasCheck){
              that.Activity2CacheData.selectReceiveId = that.selectReceiveId;
              that.Activity2CacheData.selectReceiveVal = that.selectReceiveVal;
              that.Activity2CacheData.selectReceiveCode = that.selectReceiveCode;
              that.saveLocation();;//缓存填写数据
            }
          } else {
            that.Activity2CacheData.selectReceiveId = that.selectReceiveId;
            that.Activity2CacheData.selectReceiveVal = that.selectReceiveVal;
            that.Activity2CacheData.selectReceiveCode = that.selectReceiveCode;
            that.saveLocation();;//缓存填写数据
          }
        }
        setTimeout(() => {
          that.isShowSelect = true;
        }, 500);//重新渲染select组件
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      console.log(error);
    });

  }

  /**
   * 拍照
   */
  async getCamera(type) {
    console.log(type);
    let that = this;
    let option = {
      // header: '',
      buttons: [{
        text: '拍照',
        handler: () => {
          console.log('拍照');
          that.nativeService.getCameraPictureUrl({ saveToPhotoAlbum: true, quality: app.activityquality || 15 }).then(fileUrl => {
            that.uploadImg(fileUrl, type, false, 0);
          })
        }
      }, {
        text: '相册',
        handler: () => {
          console.log('相册');
          that.nativeService.getImagePickerUrl({ saveToPhotoAlbum: true, quality: app.activityquality || 15 }).then(fileUrl => {
            that.uploadImg(fileUrl, type, false, 0);
          })
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    };
    const actionSheet = await this.actionSheet.create(option);
    await actionSheet.present();
  }

  /**
   * 上传图片
   * @param fileUrl fileUrl
   * @param type 活动现场照片
   * @param isReUpload 是否重新上传
   * @param index 哪张从新上传
   */
  uploadImg(fileUrl, type, isReUpload, index) {
    let that = this;
    if (isReUpload) {//重新上传获取图片base64 url
      fileUrl = that.imgUrlSceneArr[index]["url"];
    }
    let FILE_URI = fileUrl;
    let transfer = new FileTransfer();
    console.log(FILE_URI, "FILE_URI");
    const fileTransfer: FileTransferObject = transfer.create();
    let options: FileUploadOptions = {
      fileKey: 'file',
      fileName: that.nativeService.GetImgFileName() + ".jpg",
      // mimeType: "image/jpeg",
      httpMethod: "post",
      headers: null
    };
    let _msg = "已上传"
    that.msg.Loading(_msg).then(load => {
      fileTransfer.upload(FILE_URI, app.UPLOADURL, options).then(data => {
        load.dismiss();
        if (data.responseCode == 200) {
          let message = JSON.parse(data.response);
          console.log(message, "res");
          if (message.ResponseMessage.Success && message.Status.length > 0) {
            let _imgName = message.Status[0].FileName;
            let _url = app.FileUoloadUrl + _imgName.trim().replace(app.ImagePlaceholder, app.SmallImageType);
            // item.url.trim().replace(app.SmallImageType,app.BigImageType);
            let _obj = { url: _url, name: _imgName, isUpload: true };
            if (isReUpload) {
              that.imgUrlSceneArr[index] = _obj;
            } else {
              that.imgUrlSceneArr.push(_obj);
            }
          } else {
            that.msg.Alert("上传失败,请检查网络！");
            let _obj = { url: FILE_URI, name: null, isUpload: false };
            if (isReUpload) {
              that.imgUrlSceneArr[index] = _obj;
            } else {
              that.imgUrlSceneArr.push(_obj);
            }
          }
          localStorage.setItem("activity_" + type, JSON.stringify(that.imgUrlSceneArr));
        }
      }).catch(error => {
        load.dismiss();
        console.log(error);
        that.msg.Alert("上传失败,请检查网络！");
        let _obj = { url: FILE_URI, name: null, isUpload: false };
        if (isReUpload) {
          that.imgUrlSceneArr[index] = _obj;
        } else {
          that.imgUrlSceneArr.push(_obj);
        }
        localStorage.setItem("activity_" + type, JSON.stringify(that.imgUrlSceneArr));
      });
      fileTransfer.onProgress((event: ProgressEvent) => {
        let num = Math.floor(event.loaded / event.total * 100);
        console.log(num, "百分比")
        if (num === 100) {
          load.message = '上传完成';
          load.dismiss();
        } else {
          let title = num;
          title && (load.message = _msg + num + '%');
        }
      });
      load.present();
    })
  }

  /**
   * 重新上传
   * @param index 第几张照片
   * @param type 类型：活动现场照片
   */
  reUpload(index, type) {
    this.uploadImg("", type, true, index);
  }

  LoadData() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    // console.log("12121221");
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else {
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    body.ConfigName = "Particulars";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (that.Activity2CacheData.isRelationActivity) {

      const _param = that.activaRouter.snapshot.paramMap.get('id').split("&");
      let vipId = '';
      let actId = '';
      if (_param.length > 5) {
        actId = _param[3];
        vipId = _param[4];
      } else {
        that.msg.Alert("配置有误，请退出页面重试");
        return;
      }
      body.RequestBody = JSON.stringify({
        "a_ID": id,
        "a_FK_MembersInfoManagement_ID": vipId,
        "a_FK_TBActivity_ID": actId
      });
    } else {
      body.RequestBody = JSON.stringify({ "a_ID": id });
    }
    // body.RequestBody=JSON.stringify({"a_ID":id,"flag":that.flag});
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        that.object = data.Status;
        if(that.Activity2CacheData){
          that.object.milkNum = that.Activity2CacheData.milkNum || null;
          that.object.otherNum = that.Activity2CacheData.otherNum || null;
        }
        if (that.Activity2CacheData.isRelationActivity) {
          that.getReceiveList();//赠送类别
          if (that.object["SignInfo"] && JSON.stringify(that.object["SignInfo"]) != "{}") {
            that.orderInfo = {
              IsOrder: that.object.SignInfo["IsOrder"],
              Name: that.object.SignInfo["b_Name"],
              TelPhone: that.object.SignInfo["b_TelPhone"],
              Register_time: that.object.SignInfo["b_Register_time"],
              FirstOrderTime: that.object.SignInfo["c_FirstOrderTime"],
              FK_MembersInfoManagement_ID: that.object.SignInfo["a_FK_MembersInfoManagement_ID"],
              // FirstOrderTime:that.object.SignInfo["c_FirstOrderTime"],
              // FirstOrderTime:that.object.SignInfo["c_FirstOrderTime"],
            }
            if (that.orderInfo["TankBarcodes"]) {
              that.orderInfo["TankBarcodes"] = that.orderInfo["TankBarcodes"].split(",");
            }
          }
          that.orderListArr = that.object["OrderList"] || [];
          if (that.orderListArr.length > 0) {
            that.orderListArr.forEach(item=>{
              if (item["TankBarcodes"]) {
                item["TankBarcodes"] = item["TankBarcodes"].split(",");
              }
            })
            that.orderInfo = that.orderListArr[0];
            that.actOrderInfoId = that.orderInfo["Order_ID"];
          }
          
        }
        const _userMechanism = that.com.GetStorageKey("userMechanism");//缓存活动机制
        if (_userMechanism) {
          that.object["Mechanism"] = _userMechanism;
        }

        const u_ID = that.object["u_ID"] || null;
        that.isFuzeren = u_ID == that.com.GetAccount.Id;


        if (!that.object.Address) {
          that.getLocation();
        };
        that.isBeginSevenDay = that.DateComparison(that.object["a_StartTime"]);
        that.isEnd = that.DateComparison2(that.object["a_EndTime"]);
        that.isendSevenDay = that.DateComparisonEnd(that.object["a_EndTime"]);
        if (that.object) {
          if (that.object["a_DoorwayPicture"]) {//门头照
            that.imgUrlArr = (that.getCameraList("a_DoorwayPicture", that.object["a_DoorwayPicture"]));
          }
          if (that.object["a_SignInPicture"]) {//签到照
            that.imgUrlSignInArr = (that.getCameraList("a_SignInPicture", that.object["a_SignInPicture"]));
          }
          if (that.object["a_ScenePicture"]) {//现场照片------------
            that.imgUrlSceneArr = (that.getCameraList("a_ScenePicture", that.object["a_ScenePicture"]));
          }
          if (that.object["a_ActivityMechanismPicture"]) {//活动机制照片
            that.imgUrlActivityArr = (that.getCameraList("a_ActivityMechanismPicture", that.object["a_ActivityMechanismPicture"]));
          }
          if (that.object["a_OtherPicture"]) {//其他照片
            that.imgUrlOtherArr = (that.getCameraList("a_OtherPicture", that.object["a_OtherPicture"]));
          }
        }
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.msg.Alert(app.ERRORMESSAGE);
      console.log(error);
    });

  }

  /**
   * 验证奶卡卡号
   */
  verificaMilkNum() {
    const that = this;
    // return new Promise((resolve,reject)=>{
    // })
    let _obj = {
      "ConfigName": "ActivityNumcar",
      "OpType": "query",
      "ConfigType": "view",
      "RequestBody": JSON.stringify({ "CardNum": that.object.milkNum, "OtherNum": "0" })
    };
    that.http.post(app.DEFAULTURL, _obj).then(data => {
      if (data.ResponseMessage.Success) {
        if (data.Status) {
          that.isValidMilk = true;
        } else {
          that.isValidMilk = false;
          that.msg.Alert("奶卡卡号不正确");
        }
      }
    });

  }

  /**
   * 验证卡号或编号
   */
  verificaNum(): Promise<any> {
    const that = this;
    let _obj = {};
    if (that.selectReceiveCode == "GC001" || that.selectReceiveCode == "GC005") {
      _obj = {
        "ConfigName": "ActivityNumcar",
        "OpType": "query",
        "ConfigType": "view",
        "RequestBody": JSON.stringify({ "CardNum": that.object.milkNum })
      };

    } else if (that.selectReceiveCode == "GC002" || that.selectReceiveCode == "GC004") {
      _obj = {
        "ConfigName": "ActivityNumcar",
        "OpType": "query",
        "ConfigType": "view",
        "RequestBody": JSON.stringify({ AotherNum: that.object.otherNum })
      };
    }
    return new Promise((resolve, reject) => {
      that.http.post(app.DEFAULTURL, _obj).then(data => {
        resolve(data);
      }).catch(err => {
        reject(err);
      });
    });

  }

  /**
   * 处理奶卡卡号数据
   * @param event 
   * @param type 
   */
  EventChanage(event, type) {
    const code = new RegExp("^[0-9]*$");
    let that = this;
    if (type == 1) {
      if (event.target.value != null && event.target.value != "null" && typeof (event.target.value) != "undefined") {
        let numvalue: any = event.target.value;
        if (code.test(numvalue)) {
          if (numvalue.toString().trim().length <= 8) {
            that.object.milkNum = numvalue;
            that.milkNumOld = that.object.milkNum;
            event.target.value = numvalue;
          } else {
            that.object.milkNum = that.milkNumOld;
            event.target.value = that.milkNumOld;
          }
        } else {
          that.object.milkNum = that.milkNumOld;
          event.target.value = that.milkNumOld;
        }
      } else {
        that.object.milkNum = null;
        event.target.value = null;
      }
      that.Activity2CacheData.milkNum = that.object.milkNum;
      that.saveLocation();;//缓存填写数据
    } else {
      if (event.target.value != null && event.target.value != "null" && typeof (event.target.value) != "undefined") {
        let numvalue: any = event.target.value;
        if (code.test(numvalue)) {
          if (numvalue.toString().trim().length <= 16) {
            that.object.otherNum = numvalue;
            that.otherNumOld = that.object.otherNum;
            event.target.value = numvalue;
          } else {
            that.object.otherNum = that.otherNumOld;
            event.target.value = that.otherNumOld;
          }
        } else {
          that.object.otherNum = that.otherNumOld;
          event.target.value = that.otherNumOld;
        }
      } else {
        that.object.otherNum = null;
        event.target.value = null;
      }
      that.Activity2CacheData.otherNum = that.object.otherNum;
      that.saveLocation();;//缓存填写数据
    }
  }

  // EventBlur(type) {
  //   const that = this;
  //   if (type == 1) {
  //     if (!that.object.milkNum || that.object.milkNum.length != 8) {
  //       that.msg.Alert("请输入正确的奶卡卡号");
  //     } else {
  //       that.verificaMilkNum();
  //     }
  //   } else {
  //     if (!that.object.otherNum || that.object.otherNum.length != 16) {
  //       that.msg.Alert("请输入正确的编号");
  //     } else {
  //       that.verificaOtherNum();
  //     }
  //   }
  // }

  getCameraList(picture, obj) {
    const that = this;
    let tempArray: Array<any> = new Array<any>();
    let imgUrl = obj;
    let _activityImg = localStorage.getItem("activity_" + picture);
    if (_activityImg) {
      tempArray = JSON.parse(_activityImg);
    } else {
      if (imgUrl) {
        let arr = imgUrl.split(",");
        arr.forEach(item => {
          let _obj = {
            url: (app.FileUoloadUrl + item).replace(app.ImagePlaceholder, app.SmallImageType),
            name: item
          };
          tempArray.push(_obj);
        });
      }
    }
    return tempArray;

  }

  async EditImg(i, picture) {
    const that = this;
    let _option: any = {};
    let type: any = that.activaRouter.snapshot.paramMap.get('type');
    if (type == "view") {
      that.imgPreview(i, picture);
      return;
    }
    let _option1 = {
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          console.log('预览');
          that.imgPreview(i, picture);
        }
      }, {
        text: '删除',
        handler: () => {
          console.log("删除");
          if (that[picture]) {
            that[picture].splice(i, 1);
            localStorage.setItem("activity_a_ScenePicture", JSON.stringify(that.imgUrlSceneArr));
          }
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    };
    let _option2 = {
      // header: '',
      buttons: [{
        text: '删除',
        handler: () => {
          console.log("删除2019");
          if (that[picture]) {
            that[picture].splice(i, 1);
            localStorage.setItem("activity_a_ScenePicture", JSON.stringify(that.imgUrlSceneArr));
          }
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    };
    let isUpload = that.imgUrlSceneArr[i]["isUpload"];
    if (isUpload) {
      _option = _option1;
    } else {
      _option = _option2;
    }
    const actionSheet = await this.actionSheet.create(_option);
    await actionSheet.present();
  }
  imgPreview(i, picture) {
    let that = this;
    let url = [];
    if (that[picture]) {
      that[picture].forEach(item => {
        let u = null;
        if (item.url.indexOf("data:") > -1) {
          u = item.url
        } else {
          u = item.url.trim().replace(app.SmallImageType, app.BigImageType);
        }
        url.push(u);
      });
      let ImgPreview = {
        imgUrl: url,
        index: i
      }
      that.com.setHistoryUrl(false);
      that.com.Go("/tabs/contact/ImgPreview/" + that.com.getNowDatetime,{ ImgPreview: JSON.stringify(ImgPreview)});
      // that.router.navigate(["/tabs/contact/ImgPreview/" + that.com.getNowDatetime], {
      //   queryParams: {
      //     ImgPreview: JSON.stringify(ImgPreview)
      //   }
      // });
    }


  }


  /**
 * 保存数据
 * @param obj 保存数据
 */
  saveData(obj, loads) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = "ActivityDetail";
    body.OpType = "ADD";
    body.ConfigType = "form";
    // body.RowsPerPage = app.RowsPerPage;
    // body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = JSON.stringify(obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      that.isSubmitData = true;
      if (data.ResponseMessage.Success) {
        /**
         * 清除活动缓存数据
         */
        localStorage.removeItem("activity_a_ScenePicture");
        localStorage.removeItem("Activity2CacheData_" + that.com.GetAccount.Id +"_"+that.activityId);
        localStorage.removeItem("Activity2CacheData_MMB_" + that.com.GetAccount.Id +"_"+that.activityId);
        localStorage.removeItem("orderInfo_"+that.com.GetAccount.Id+"_"+that.activityId);//删除扫活动码会员信息
        let _Activity2CacheData: any = {
          formId: "",//表单id
          selectReceiveId: that.Activity2CacheData.selectReceiveId,//赠送类别id
          selectReceiveCode: that.Activity2CacheData.selectReceiveCode,//赠送类别code
          selectReceiveVal: that.Activity2CacheData.selectReceiveVal,//赠送类别名称
          Remarks: "",//定位备注
          milkNum: "",//奶卡卡号
          otherNum: "",//其他编号
          orderId: null,//扫码销量订单号
          orderQrCodeUrl: "",//订单二维码
          actQrCodeIsUsed: false,//活动码已使用
          isRelationActivity: that.Activity2CacheData.isRelationActivity//是否关联妈妈班
        };//活动缓存数据
        that.Activity2CacheData = _Activity2CacheData;
        that.saveLocation();
        that.msg.Alert("提交数据成功").then(fail => {
          if (fail) {
            that.com.goBack();
          }
        });
      } else {
        loads.dismiss();
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
    }).catch(error => {
      that.isSubmitData = true;
      console.log(error);
      loads.dismiss();
      that.msg.Alert(app.ERRORMESSAGE);
    });
  }

  /**
   * 验证妈妈班是否存在销量订单
   */
  activityIsHaveOrder(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      // let _obj = {
      //   "ConfigName": "ActivityNumcar",
      //   "OpType": "query",
      //   "ConfigType": "view",
      //   "RequestBody": JSON.stringify({"CardNum":that.object.milkNum,"OtherNum":"0"})
      // };
      let _body = {
        "a_FK_TBActivity_ID": that.object.a_ID,//鲜入为主活动id
        "a_ID": that.object.a_FormID,//表单id
      };
      if (that.selectActivityId != "000000") {//关联的妈妈班id
        _body["a_FK_TBActivity_Correla_ID"] = that.selectActivityId;
      }
      //TODO: 绑定销量订单号
      const milkActivityOrder = localStorage.getItem("milkActivityOrder");
      if (that.selectActivityId == '000000' && milkActivityOrder) {
        _body["a_Order_ID"] = milkActivityOrder;
      }

      let _obj = {
        "ConfigName": "MembersRelationActivityOrder",
        "OpType": "query",
        "ConfigType": "view",
        "RequestBody": JSON.stringify(_body)
      }
      that.http.post(app.DEFAULTURL, _obj).then(data => {
        resolve(data);
      }).catch(err => {
        reject(err);
      });
    })
  }


  /**
   * 提交处理数据
   */
  EventClick() {
    const that = this;
    console.log(that.object, "object");
    // return;
    if (!that.isSubmitData) {
      return;
    } else {
      that.isSubmitData = false;
    }
    let _obj = {};
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    /**
     * 定位信息验证
     */
    if(!that.locationIsLoading){
      that.msg.Alert("请等待定位完成！");
      that.isSubmitData = true;
      return;
    }
    if(that.locationerror && !that.object.Remarks){
      that.msg.Alert("定位失败，请填写备注！");
      that.isSubmitData = true;
      return;
    }
    if (!that.object["Mechanism"]) {
      that.msg.Alert("请输入活动机制");
      that.isSubmitData = true;
      return;
    }
    if (that.selectReceiveCode == 'GC001' || that.selectReceiveCode == 'GC005') {
      if (!that.object.milkNum || that.object.milkNum.toString().trim().length != 8) {
        that.msg.Alert("请输入正确的奶卡卡号");
        that.isSubmitData = true;
        return;
      } else {
        that.object.otherNum = null;
        that.otherNumOld = null;
      }
    }
    if (that.selectReceiveCode == 'GC002' || that.selectReceiveCode == 'GC004') {
      if (!that.object.otherNum || that.object.otherNum.toString().trim().length != 16) {
        that.msg.Alert("请输入正确的编号");
        that.isSubmitData = true;
        return;
      } else {
        that.object.milkNum = null;
        that.milkNumOld = null;
      }

      if(that.orderInfo["TankBarcodes"] && that.orderInfo["TankBarcodes"].toString().indexOf(that.object.otherNum) > -1){
        that.msg.Alert("其他编码不能与销售罐码重复");
        that.isSubmitData = true;
        return;
      }

    }

    //
    /**
     * 赠送类别为以下类型时，上传图片
     * 奶卡-消费送 GC005；
     * 奶卡-非消费送 GC001
     */
    if (that.selectReceiveCode == 'GC001' || that.selectReceiveCode == 'GC005') {
      if (that.imgUrlSceneArr.length == 0) {
        that.msg.Alert("请上传图片");
        that.isSubmitData = true;
        return;
      }
      let isHaveUploadError = false;
      that.imgUrlSceneArr.forEach(item => {
        if (!item["isUpload"]) {
          isHaveUploadError = true;
        }
      })
      if (isHaveUploadError) {
        that.msg.Alert("您有未上传成功的照片，请先上传或删除后再保存！");
        that.isSubmitData = true;
        return;
      }

      _obj["a_GiftPicture"] = "";//奶卡照片
      that.imgUrlSceneArr.forEach(item => {
        if (!_obj["a_GiftPicture"]) {
          _obj["a_GiftPicture"] = item.name;
        } else {
          _obj["a_GiftPicture"] += "," + item.name;
        }
      })
    }
    _obj["a_FK_TBActivity_ID"] = that.object.a_ID;
    
    _obj["a_Address"] = that.object.Address;//定位地址
    _obj["a_Longitude"] = that.object.Longitude;//经度
    _obj["a_Latitude"] = that.object.Latitude;//纬度
    _obj["a_Remarks"] = that.object.Remarks || "";//定位失败备注
    _obj["a_Mechanism"] = that.object.Mechanism;//活动机制
    _obj["a_FK_GiftsCategory_Bind_ID"] = that.selectReceiveId;//赠送类别ID
    _obj["a_MilkCode"] = that.selectReceiveCode;//赠送类别code


    if (that.selectReceiveCode == "GC002" || that.selectReceiveCode == "GC004") {
      _obj["a_OtherNum"] = that.object.otherNum || null;//其他卡号
    }
    if (that.selectReceiveCode == "GC001" || that.selectReceiveCode == "GC005") {
      _obj["a_CardNum"] = that.object.milkNum || null;//奶卡卡号
    }

    if(!that.Activity2CacheData.isRelationActivity){//鲜入为主
      if (that.selectReceiveCode == "GC001" || that.selectReceiveCode == "GC004") {
        if(that.Activity2CacheData.freshIntakeCode){
          _obj["a_FormID"] = that.Activity2CacheData.freshIntakeCode;//活动码唯一
        }else{
          that.msg.Alert("请先扫活动码，无法提交");
          that.isSubmitData = true;
          return;
        }
      }

      if(that.selectReceiveCode == "GC002" || that.selectReceiveCode == "GC003" || that.selectReceiveCode == "GC005") {
        if (that.Activity2CacheData.orderId) {
          _obj["a_Order_ID"] = that.Activity2CacheData.orderId;
        }else{
          that.msg.Alert("请先扫码销量，无法提交");
          that.isSubmitData = true;
          return;
        }
      }

    }else{//妈妈班关联
      _obj["a_FK_TBActivity_Correla_ID"] = that.selectActivityId;//妈妈班活动ID
      _obj["a_FK_MembersInfoManagement_ID"] = that.vipId;

      // if(that.selectReceiveCode == "GC002" || that.selectReceiveCode == "GC003" || that.selectReceiveCode == "GC005") {
      // }
      if(that.actOrderInfoId){
        _obj["a_Order_ID"] = that.actOrderInfoId;//订单id
      }
    }
   

    /**
     * 验证卡号正确性
     */
    that.msg.Confirm("您当前选择的赠送类别是“"+that.Activity2CacheData.selectReceiveVal+"”，确认保存？").then(data=>{
      if(data){
        that.msg.Loading("加载中").then(loads => {
          that.saveData(_obj, loads);//保存数据
          loads.present();
        })
      }else{
        that.isSubmitData = true;
      }
    })


    // that.msg.Loading("加载中").then(loads => {
    //   that.saveData(_obj, loads);//保存数据
    //   loads.present();


    //   // that.verificaNum().then(data => {
    //   //   if (data.ResponseMessage.Success) {
    //   //     if (data.Status) {
    //   //       // if (that.selectReceiveCode == "GC002" || that.selectReceiveCode == "GC004") {
    //   //       // /**
    //   //       //  * 验证妈妈班活动是否存在订单
    //   //       //  */
    //   //       // that.activityIsHaveOrder().then(data => {
    //   //       //   that.isSubmitData = true;
    //   //       //   if (data.ResponseMessage.Success) {
    //   //       //     if (data.Status.State == 1) {
    //   //       //       that.saveData(_obj, loads);//保存数据
    //   //       //     } else if (data.Status.State == 2) {
    //   //       //       loads.dismiss();
    //   //       //       that.msg.Confirm("注意此会员非首次购买，无法核销，是否继续保存？").then(data => {
    //   //       //         if (data) {
    //   //       //           that.saveData(_obj, loads);//保存数据
    //   //       //         }
    //   //       //       });
    //   //       //     }
    //   //       //   } else {
    //   //       //     loads.dismiss();
    //   //       //     that.msg.Alert(data.ResponseMessage.ErrorMessage);
    //   //       //   }
    //   //       // }).catch(err => {
    //   //       //   loads.dismiss();
    //   //       //   that.msg.Alert(app.ERRORMESSAGE);
    //   //       //   that.isSubmitData = true;
    //   //       // })

            

    //   //       // if (that.selectReceiveCode == "GC001") {//奶卡-非消费类

    //   //       // } else if (that.selectReceiveCode == "GC002") {//其他-买赠

    //   //       // } else if (that.selectReceiveCode == "GC003") {//其他-优惠/礼包

    //   //       // } else if (that.selectReceiveCode == "GC004") {//其他-完全赠送

    //   //       // } else if (that.selectReceiveCode == "GC005") {//奶卡-消费送
    //   //       //   // that.saveData(_obj, loads);//保存数据
    //   //       // }
    //   //     } else {
    //   //       that.isSubmitData = true;
    //   //       loads.dismiss();
    //   //       if (that.selectReceiveCode == 'GC001' || that.selectReceiveCode == 'GC005') {
    //   //         that.msg.Alert("奶卡不正确");
    //   //       } else if (that.selectReceiveCode == 'GC002' || that.selectReceiveCode == 'GC004') {
    //   //         that.msg.Alert("编号不正确");
    //   //       }
    //   //     }
    //   //   } else {
    //   //     loads.dismiss();
    //   //     that.msg.Alert(data.ResponseMessage.ErrorMessage);
    //   //   }
    //   // }).catch(err => {
    //   //   that.msg.Alert(app.ERRORMESSAGE);
    //   //   that.isSubmitData = true;
    //   //   loads.dismiss();
    //   // })
    //   // loads.present();
    // })


  }


  /**
   * 判断是否多张照片
   * @param arrayObj 
   */
  getPictureobj(arrayObj: Array<any>) {
    const that = this;
    let reustl = "";
    if (arrayObj.length > 0) {
      let imgName = null;
      arrayObj.forEach(item => {
        if (item.name) {
          if (imgName) {
            imgName += ',' + item.name;
          } else {
            imgName = item.name;
          }
        }
      });
      reustl = imgName;
    }
    return reustl;
  }

  /**
   * 
   * @param date1 活动开始日期
   */
  DateComparison(date) {
    let nowDate = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
    let actDate = new Date(date.replace(/-/g, "/")).getTime();
    return nowDate < actDate;
  }

  /**
   * 
   * @param date1 活动结束日期 已结束为true
   */
  DateComparison2(date) {
    let nowDate = new Date().getTime();
    let actDate = new Date(date.replace(/-/g, "/")).getTime();
    return nowDate > actDate;
  }
  /**
  * 
  * @param date1 活动结束后3天之内 3天之外为true
  */
  DateComparisonEnd(date) {
    console.log(date);
    console.log(this.flag);
    let nowDate = new Date().getTime();//当前日期  
    let actDate = new Date(date.replace(/-/g, "/")).getTime() + 3 * 24 * 60 * 60 * 1000;//结束日期
    return actDate > nowDate;
  }


  /**
   * 
   * @param $event event
   * @param n 0 开始时间；1结束时间
   */
  DateChange($event, n) {
    console.log($event);
    let date = $event.detail.value;
    date = date.replace("T", " ").replace("Z", "").replace("-00:00", "");
    if (n == 0) {
      this.object.a_StartTime = date;
    } else {
      this.object.a_EndTime = date;
    }
    let d1 = new Date(this.object.a_StartTime.replace(/-/g, "/")).getTime();
    let d2 = new Date(this.object.a_EndTime.replace(/-/g, "/")).getTime();
    if (d1 >= d2) {
      this.msg.Alert("开始日期不得大于或等于结束日期！");
    }
    console.log(date, "---------date--------", this.object.startTime, this.object.endTime);
  }

  /**
  * 签到地址二维码
  * 
  */
  orderQRCode(url) {
    const that = this;
    console.log(url, "扫活动码");
    console.log(that.orderInfo,"info");
    if (url) {
      that.com.setHistoryUrl(false);
      that.com.GUID().then(data => {
        //  data="0B5CCF9F-4637-4E04-A3D8-72F54CD9A625";
        if (url.toString().indexOf("?") != -1) {
          url = url + "&fromId=" + data;
        } else {
          url = url + "?fromId=" + data;
        }
        setTimeout(()=>{
          that.isfreshIntake = true;
        },1000);
        that.Activity2CacheData.freshIntakeCode = data;//获取活动码
        that.Activity2CacheData.orderQrCodeUrl = url;//获取活动二维码
        that.saveLocation();
        let parms = { "a_FK_SystemUser_Create_ID": that.com.GetAccount.Id };
            parms["a_FormID"] = that.Activity2CacheData.freshIntakeCode;
            parms["a_FK_TBActivity_ID"] = that.activityId;
            localStorage.setItem("orderQRCode",JSON.stringify(parms));
         that.com.goQrCode(url, 'activityCode', "扫活动码");
      });
    }
  }

  //  扫码销量


  salesQRCode() {
    const that = this;

    let _body = {
      "a_FK_TBActivity_ID": that.object.a_ID,
      "a_ID": that.object.a_FormID
    };
    let _obj = {
      "ConfigName": "MembersIsSign",
      "OpType": "query",
      "ConfigType": "view",
      "RequestBody": JSON.stringify(_body)
    }
    this.com.setHistoryUrl(false);
    that.com.Go("/tabs/contact/ScanCodeSales/add/" + this.activityId + "&milkActivity&" + this.com.getNowDatetime);
    // that.router.navigate(["/tabs/contact/ScanCodeSales/add/" + this.activityId + "&milkActivity&" + this.com.getNowDatetime]);
    // that.msg.Loading("加载中...").then(loads => {
    //   that.http.post(app.DEFAULTURL, _obj).then(data => {
    //     loads.dismiss();
    //     if (data.ResponseMessage.Success) {
    //       this.com.setHistoryUrl(false);
    //       that.router.navigate(["/tabs/contact/ScanCodeSales/add/" + this.activityId + "&milkActivity&" + this.com.getNowDatetime]);
    //     } else {
    //       that.msg.Alert(data.ResponseMessage.ErrorMessage);
    //     }
    //   }).catch(err => {
    //     loads.dismiss();
    //     that.msg.Alert(app.ERRORMESSAGE);
    //   });
    //   loads.present();
    // })
  }

  /**
   * 获取焦点、失去焦点
   * @param event 事件
   * @param inputType 输入类型
   */
  focusOrBlurEvent(event, inputType) {
    if (this.platform.is("android")) {
      const directiveClass: any = document.getElementsByClassName("ActivityCenterDetail2DirectiveClass");
      let directiveClassDom: any = null;
      if (directiveClass && directiveClass.length > 0) {
        directiveClassDom = directiveClass[directiveClass.length - 1];
      } else {
        return;
      }
      if (event && event.type == "ionFocus") {
        directiveClassDom.style.paddingBottom = "180px";
      } else if (event && event.type == 'ionBlur') {
        directiveClassDom.style.paddingBottom = "0";
      }
    }
    if (inputType == 'mechanism') {
      // this.Activity2CacheData.Mechanism = event.target.value;
      localStorage.setItem("userMechanism", JSON.stringify(event.target.value));//缓存填写数据
    }
  }
  hideKeyboard() {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    if (PageName != 'ActivityCenterDetail2') { return; }
    if (that.platform.is("android")) {
      that.keyboard.onKeyboardHide().subscribe((data) => {
        const directiveClass: any = document.getElementsByClassName("ActivityCenterDetail2DirectiveClass");
        if (directiveClass && directiveClass.length > 0) {
          directiveClass[directiveClass.length - 1].style.paddingBottom = "0";
        }
      })
    }
  }

}
